<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import type { NetworkListEntry } from "../../../../../../admin-service-typescript-client";
    import { locationStore } from "../../../../../store/locations";
    import { networkStore } from "../../../../../store/networks";

    const navigate = useNavigate();
    export let network: NetworkListEntry;
    export let clickable: boolean;
    export let mainImage: boolean = true;
</script>

<div
    class="card {clickable && 'clickable'} full-height full-width"
    on:click={() => {
        if (clickable) {
            networkStore.update((store) => {
                return { ...store, network: null };
            });
            locationStore.update((store) => {
                return { ...store, location: null };
            });
            navigate(network.id);
        }
    }}
>
    {#if mainImage}
        <div class="card-image">
            <figure class="image is-4by3">
                <img
                    src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                    alt="Placeholder"
                />
            </figure>
        </div>
    {/if}
    <div class="card-content">
        <div class="media">
            <div class="media-left">
                <figure class="image is-48x48">
                    <img
                        src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                        alt="Placeholder"
                    />
                </figure>
            </div>
            <div class="media-content">
                <p class="title is-4">{network.name}</p>
                <p class="subtitle is-4">
                    {network.active ? "aktiv" : "inaktiv"}
                </p>
            </div>
        </div>

        <div class="content" />
    </div>
</div>

<style>
    .media-content {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .title,
    .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .clickable {
        cursor: pointer;
    }

    .full-height {
        height: 100%;
    }

    .full-width {
        width: 100%;
    }
</style>
